import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/approach", label: "Therapeutic Approach", testId: "nav-approach" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md border-b"
      style={{
        backgroundColor: "rgba(244, 239, 228, 0.82)",
        borderColor: "rgba(201, 192, 171, 0.6)",
      }}
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          className="group leading-none"
          data-testid="nav-logo"
          onClick={() => setOpen(false)}
        >
          <span
            className="font-serif-display text-2xl md:text-[26px] tracking-tight"
            style={{ color: "var(--mc-ink)", fontWeight: 400 }}
          >
            Maxfield Counselling
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testId}
              className="text-sm font-light tracking-wide transition-colors duration-300 relative"
              style={({ isActive }) => ({
                color: isActive ? "var(--mc-ink)" : "var(--mc-ink-2)",
              })}
            >
              {({ isActive }) => (
                <>
                  {l.label}
                  <span
                    className="absolute -bottom-1.5 left-0 right-0 h-px transition-opacity duration-300"
                    style={{
                      backgroundColor: "var(--mc-ink)",
                      opacity: isActive ? 1 : 0,
                    }}
                  />
                </>
              )}
            </NavLink>
          ))}
          <a
            href="mailto:cmaxfield3@hotmail.com"
            className="text-sm tracking-wide px-5 py-2 rounded-full transition-colors duration-300"
            style={{
              backgroundColor: "var(--mc-ink)",
              color: "var(--mc-bg)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--mc-ink-2)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--mc-ink)")
            }
            data-testid="nav-book-cta"
          >
            Book a Session
          </a>
        </nav>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-nav-toggle"
          style={{ color: "var(--mc-ink)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t"
          style={{
            borderColor: "rgba(201, 192, 171, 0.6)",
            backgroundColor: "var(--mc-bg)",
          }}
          data-testid="mobile-nav"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testId}`}
                className="font-serif-display text-2xl"
                style={{ color: "var(--mc-ink)" }}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href="mailto:cmaxfield3@hotmail.com"
              className="mt-2 text-sm tracking-wide px-5 py-3 rounded-full text-center"
              style={{ backgroundColor: "var(--mc-ink)", color: "var(--mc-bg)" }}
              data-testid="mobile-book-cta"
              onClick={() => setOpen(false)}
            >
              Book a Session
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
